import classNames from 'classnames';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { FormattedMessage } from 'react-intl';
import { useAppSelector } from '../../configuration/setup/hooks';
import { useGetAssetDataQuery } from '../../store/facade/facadeApiV3';
import { VEHICLE_DATA_POLLING_FREQ } from '../../common/constants';
import { selectIsVehicleSwitchPending, selectVehicleProfile } from '../../store/vehicleProfile/vehicleProfileSelectors';

export const VehicleStatusIndicator = () => {
    const assetId = useAppSelector(selectVehicleProfile).assetLocked?.asset_id;
    const isVehicleSwitchPending = useAppSelector(selectIsVehicleSwitchPending);
    const { data: vehicleData } = useGetAssetDataQuery(
        { id: assetId ?? '' },
        { skip: !assetId, pollingInterval: VEHICLE_DATA_POLLING_FREQ * 1000 }
    );

    if (!assetId) {
        return null;
    }

    if (isVehicleSwitchPending) {
        return <Spinner show isFullSized />;
    }

    const vehicleStateClasses = vehicleData?.state?.ignition_on
        ? classNames('badge-success', 'badge-indicator-pinging')
        : classNames('badge-default');

    const tooltipText = vehicleData?.state?.ignition_on
        ? 'intl-msg:smartRoute.generic.vehicleStatus.online'
        : 'intl-msg:smartRoute.generic.vehicleStatus.offline';

    return (
        <SimpleTooltip content={<FormattedMessage id={tooltipText} />} placement='top'>
            <span className='indicated-button margin-left-5'>
                <span
                    className={classNames('badge badge-indicator', vehicleStateClasses)}
                    style={{ width: 8, height: 8, minWidth: 8, minHeight: 8 }}
                />
            </span>
        </SimpleTooltip>
    );
};
